import OrdersAPI from '@/API/orders-api'
import TaxesAPIs from '@/API/ordering/taxes-api'

let fetchGroupsPromise: Promise<void> | null = null

export default {
  namespaced: true,
  state: {
    taxes: [],
    taxesFetched: false,
    groupsFetched: false,
    groups: [],
  },

  getters: {
    taxes: (state: any) => state.taxes,
    groups: (state: any) => state.groups,
    taxesFetched: (state: any) => state.taxesFetched,
  },

  mutations: {
    SET_DATA(state: any, payload: any) {
      state.taxes = payload.taxes ?? []
      state.groups = payload.groups ?? []
      state.taxesFetched = true
      state.groupsFetched = true
    },
    SET_GROUPS(state: any, groups: any) {
      state.groups = [...groups]
    },
    SET_GROUP_FETCHED(state: any) {
      state.groupsFetched = true
    },
  },

  actions: {
    async FETCH_DEPENDENCIES(context: any, force = false) {
      if (context.state.taxesFetched && !force) {
        return
      }
      try {
        const branchId = context.rootGetters['branches/currentBranchId']
        const data = await TaxesAPIs.getTaxes(branchId)
        context.commit('SET_DATA', data)
      } catch (err) {
        console.error(err)
      }
    },
    async FETCH_GROUPS(context: any, { force = false, branchID = null } = {}) {
      if (context.state.groupsFetched && !force) {
        return
      }
      const branchId = branchID ?? context.rootGetters['branches/currentBranchId']
      if (!branchId) return

      if (fetchGroupsPromise && !force) {
        return fetchGroupsPromise
      }

      fetchGroupsPromise = (async () => {
        try {
          const isSubUser = context.rootGetters['permissions/isSubUser']
          const data = isSubUser
            ? await TaxesAPIs.getTaxGroupsForItems(branchId)
            : await TaxesAPIs.getTaxGroups(branchId)
          context.commit('SET_GROUPS', data)
          context.commit('SET_GROUP_FETCHED')
        } catch (err) {
          console.error(err)
        } finally {
          fetchGroupsPromise = null
        }
      })()

      return fetchGroupsPromise
    },
    async UPDATE(context: any, payload: any) {
      // @ts-ignore
      try {
        return await OrdersAPI.updateOrder(payload)
      } catch (err: any) {
        return { response: 400, message: err?.message ?? '' }
      }
    },
  },
}
